import React, { useState } from "react";
import SmileyLoaderFull from "./SmileyLoaderFull";
import SmileyLoaderLite from "./SmileyLoaderLite";

// Desktops (mouse + wide screen) get the smiley drawn live through the spray filter; phones and
// tablets get the same smiley with the spray baked into images, which they can animate smoothly.
const DESKTOP = "(hover: hover) and (pointer: fine) and (min-width: 1024px)";

const SmileyLoader = ({ onReady }) => {
  const [full] = useState(() => typeof window !== "undefined" && window.matchMedia(DESKTOP).matches);
  return full ? <SmileyLoaderFull onReady={onReady} /> : <SmileyLoaderLite onReady={onReady} />;
};

export default SmileyLoader;
